import { render, staticRenderFns } from "./MaskView.vue?vue&type=template&id=9c0c041e&scoped=true"
import script from "./MaskView.vue?vue&type=script&lang=js"
export * from "./MaskView.vue?vue&type=script&lang=js"
import style0 from "./MaskView.vue?vue&type=style&index=0&id=9c0c041e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0c041e",
  null
  
)

export default component.exports